import "./PatientActivityLogsComponent.scss";
import React, {useCallback, useEffect, useState} from "react";
import commonService from "../../../../shared/services/common.service";
import {IAPIResponseType} from "../../../../shared/models/api.model";
import LottieFileGenarationComponent
    from "../../../../shared/components/core/lottie-file-genaration/LottieFileGenarationComponent";
import {ImageConfig} from "../../../../constants";
import StatusCardComponent from "../../../../shared/components/status-card/statusCardComponent";
import ActivityLogTimelineComponent
    from "../../../../shared/components/activity-log-timeline/ActivityLogTimelineComponent";

interface PatientActivityLogsComponentProps {
    patientId: any;
}

const PatientActivityLogsComponent = (props: PatientActivityLogsComponentProps) => {
    const {patientId} = props;

    const [patientActivityLogs, setPatientActivityLogs] = useState<any>();

    const [patientActivityLogsLoading, setPatientActivityLogsLoading] = useState<boolean>();
    const [patientActivityLogsLoadingFailed, setPatientActivityLogsLoadingFailed] = useState<boolean>();
    const [patientActivityLogsLoaded, setPatientActivityLogsLoaded] = useState<boolean>();


    const getPatientActivityLogs = useCallback(() => {
        const payload = {};
        setPatientActivityLogsLoaded(false);
        setPatientActivityLogsLoading(true);
        setPatientActivityLogsLoadingFailed(false);
        commonService._patient.getPatientLogs(patientId, payload)
            .then((res: IAPIResponseType<any>) => {
                setPatientActivityLogs(res.data);
                setPatientActivityLogsLoaded(true);
                setPatientActivityLogsLoading(false);
                setPatientActivityLogsLoadingFailed(false);
            })
            .catch((err: any) => {
                setPatientActivityLogsLoaded(true);
                setPatientActivityLogsLoading(false);
                setPatientActivityLogsLoadingFailed(true);
            })
    }, [patientId])

    useEffect(() => {
        if (patientId) {
            getPatientActivityLogs();
        }
    }, [patientId,getPatientActivityLogs])

    return (
        <div className={'patient-activity-logs-component details-tab-data-content'}>
            {
                patientActivityLogsLoading && <div className="h-v-center">
                    <LottieFileGenarationComponent
                        loop={true}
                        autoplay={true}
                        animationData={ImageConfig.LoadingLottieFile}/>
                </div>
            }
            {
                patientActivityLogsLoadingFailed && <>
                    <StatusCardComponent title={"TestOrder details failed to load"}/>
                </>
            }
            {
                patientActivityLogsLoaded && <>
                    <div className="test-order-activity-logs-tab-wrapper details-tab-data-content">
                        <div className="details-tab-data-body">
                            <ActivityLogTimelineComponent logsData={patientActivityLogs}/>
                        </div>
                    </div>
                </>
            }
        </div>
    );

};

export default PatientActivityLogsComponent;